<mat-card-header>
  <div>
    <mat-card-title class="card-title">Elected Members of Parliament</mat-card-title>
  </div>
</mat-card-header>

<table mat-table [dataSource]="dataSource">
  <ng-container *ngFor="let col of columns; let i = index;" matColumnDef="{{col.column}}">
    <th mat-header-cell *matHeaderCellDef>
      <div *ngIf="col.isRightJustify===false">{{col.label}}</div>
      <div class="value-justify-right" *ngIf="col.isRightJustify===true">{{col.label}}</div>
      <div class="value-justify-right" *ngIf="col.isRightJustify===true">{{col.labelTwo}}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <div *ngIf="col.isColour" [style.width.px]="col.minWidth">
        <mat-icon class="party-colour" [ngStyle]="{'color': element.colourCode}"> rectangle </mat-icon>
      </div>
      <div [style.min-width.px]="col.minWidth" class="value-justify-right" *ngIf="col.isRightJustify&&col.isPercent===false">
        {{element[col.column]}}
      </div>
      <div [style.min-width.px]="col.minWidth" *ngIf="col.isRightJustify===false&&col.isColour===false">{{element[col.column]}}</div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'table-row': isSmallTable}"></tr>
</table>

<mat-card-footer style="padding: 20px;">
  <div>
    * indicates that the candidate was an existing member of the Legislative Council.
  </div>
</mat-card-footer>
